import { Typography, Alert } from "@mui/material";

interface AlertInfoProps {
  title: string | JSX.Element;
  subtitle?: string;
  subtitle2?: string | JSX.Element;
}

export const AlertInfo = ({ title, subtitle, subtitle2 }: AlertInfoProps) => {
  return (
    <Alert severity="warning" icon={false} className="my-6">
      <Typography variant="subtitle1">{title}</Typography>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: "bold", marginY: "10px" }}
      >
        {subtitle}
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: "bold", marginY: "10px" }}
      >
        {subtitle2}
      </Typography>
    </Alert>
  );
};
